import { useMemo } from 'react';

import { useTranslation } from '@/i18n';
import { holidayTypeCatalogService } from '@/api/domains/catalog';
import type { HolidayType } from '@/api/domains/catalog';
import { useCatalogLoader } from '@/hooks/ui/useCatalogLoader';
import { useUI } from '@/hooks/ui/useUI';


export interface UseHolidayTypeOptionsResult {
  holidayTypeOptions: { value: string; label: string }[];
  isLoaded: boolean;
}

export function useHolidayTypeOptions(): UseHolidayTypeOptionsResult {
  const { t: translate } = useTranslation();
  const { showError } = useUI();

  const holidayTypeCatalog = useCatalogLoader<HolidayType>(
    (signal) => holidayTypeCatalogService.getHolidayTypes(signal),
    (item) => ({ value: String(item.id), label: item.name }),
    [],
    false,
    () => showError(translate('attendance:holiday.messages.loadHolidayTypeError')),
  );

  const holidayTypeOptions = useMemo(
    () => [
      { value: '', label: translate('attendance:holiday.filters.allHolidayTypes') },
      ...holidayTypeCatalog.options,
    ],
    [holidayTypeCatalog.options, translate],
  );

  return {
    holidayTypeOptions,
    isLoaded: holidayTypeCatalog.isLoaded,
  };
}

export default useHolidayTypeOptions;
